import { TextAreaProps } from '@procore/core-react/dist/_typedoc/TextArea/TextArea.types.json';
import * as React from 'react';
export default {
  TextAreaProps,
  React
};